// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"52e8a12a","3587":"9564e8ce","6040":"9564e8ce"}[chunkId] + ".chunk.css";
};